// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".paginationControls_W3vyKSip{display:flex;flex-direction:row}.show_v5pg5iI7{display:block !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paginationControls": "paginationControls_W3vyKSip",
	"show": "show_v5pg5iI7"
};
export default ___CSS_LOADER_EXPORT___;
